import { render, staticRenderFns } from "./SupplierInformationTab.vue?vue&type=template&id=3580d88e&"
import script from "./SupplierInformationTab.vue?vue&type=script&lang=js&"
export * from "./SupplierInformationTab.vue?vue&type=script&lang=js&"
import style0 from "./SupplierInformationTab.vue?vue&type=style&index=0&id=3580d88e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports